import { useQuery } from "react-query";
import { getAttributesGroup } from "components/attributes/lib/attribute-data";
import { useBuildSubgroups } from "../../components/attributes/hooks/use-build-subgroups";
import { useFlattenSubGroups } from "./use-flatten-sub-groups";

export const useAttributeSubgroups = (groupNames, codingWipKey, isBrandVerified) => {
    const buildSubgroups = useBuildSubgroups();
    const flattenSubGroups = useFlattenSubGroups();

    // TODO: unify 'groups' and 'subgroup'
    return useQuery({
        queryKey: ["attributeSubGroups", groupNames, codingWipKey],
        queryFn: async () => {
            const promises = groupNames.map((groupName) => getAttributesGroup(groupName, codingWipKey));

            return Promise.all(promises).then((attributeGroups) => {
                return {
                    attributes: flattenSubGroups(attributeGroups),
                    byGroup: {},
                    groups: attributeGroups
                        .sort((a, b) => {
                            return a.sortOrder - b.sortOrder;
                        })
                        .map((attrs) => {
                            return {
                                ...attrs,
                                name: attrs.groupName,
                                label: attrs.groupLabel,
                            };
                        }),
                    subGroups: attributeGroups.reduce((groups, group) => {
                        groups[group.groupName] = buildSubgroups(group.subGroups, isBrandVerified, group.groupName);

                        return groups;
                    }, {}),
                };
            });
        },
    });
};
